<footer class="main-footer position-relative text-white">
  <img [src]="'assets/images/footer/dog.png'" alt="dog" class="dog position-absolute end-0" />
  <div class="container">
    <div class="row align-items-end">
      <div class="col-md-5 cursor-pointer text-center text-lg-start">
        <img [src]="'assets/images/logo.png'" alt="" [routerLink]="['/']" />
      </div>
      <div class="col-md-7 mt-3 mt-md-0">
        <ul class="d-flex hours-list">
          <li>
            <span>Mon - FRI</span>
            <strong class="d-block">6 AM - 8 PM</strong>
          </li>
          <li>
            <span>SATURDAY</span>
            <strong class="d-block">6 AM - 6 PM</strong>
          </li>
          <li>
            <span>SUNDAY</span>
            <strong class="d-block">9 AM - 6 PM</strong>
          </li>
        </ul>
      </div>
      <div class="col-12 position-relative">
        <img [src]="'assets/images/footer/bird.png'" alt="bird" class="bird position-absolute" />
        <hr class="my-md-5 my-4" />
      </div>
    </div>
    <div class="row">
      <div class="col-lg-5">
        <h5 class="mb-4">About Safari</h5>
        <p class="me-md-5">
          <strong class="text-success">Safari Veterinary</strong> Care Centers
          is your one stop destination for all your pet’s needs from HealthMap
          wellness plans to advanced diagnostic medicine, orthopedic surgery,
          exotic medicine and surgery, Full Service Grooming, Hill’s Science
          Diet pet foods.
        </p>
      </div>
      <div class="col-lg-7">
        <h5 class="mb-4">Resources</h5>
        <ul class="resource-list">
          @for (plan of plans?.submenu; track $index) {
          <li class="cursor-pointer">
            <a (click)="goToPlan(plan)">{{ plan?.title | titlecase }}</a>
          </li>
          }
        </ul>
      </div>
    </div>
    <div class="row">
      <div class="col-12 px-0">
        <div class="bottom-box d-flex justify-content-between p-4 my-4 flex-column flex-xl-row">
          <div class="contact-details">
            <div>
              <div class="mb-2">League City</div>
              <ul class="d-flex hours-list flex-wrap flex-lg-nowrap">
                <li class="mt-2 mt-sm-0">
                  <span>Email</span>
                  <a href="mailto:frontdesk@safarivet.com" class="d-block link-info">frontdesk&#64;safarivet.com</a>
                </li>
                <li class="mt-2 mt-sm-0">
                  <span>Phone Number</span>
                  <a href="tel:281-332-5612" class="d-block link-info">281-332-5612</a>
                </li>
                <li class="mt-2 mt-sm-0">
                  <span>Fax</span>
                  <a href="tel:801-303-7066" class="d-block link-info">801-303-7066</a>
                </li>
                <li class="mt-lg-0 mt-2">
                  <span>Address</span>
                  <a class="d-block link-info cursor-pointer" (click)="
                      utils.getLatLongFromAddress(
                        '2402 Marina Bay Dr,League City, TX 77573, USA'
                      )
                    ">2402 Marina Bay Dr, League City, TX 77573, USA</a>
                </li>
              </ul>
            </div>
            <div>
              <div class="mb-2 mt-4">Pearland</div>
              <ul class="d-flex hours-list flex-wrap flex-lg-nowrap">
                <li class="mt-2 mt-sm-0">
                  <span>Email</span>
                  <a href="mailto:pearland@safarivet.com" class="d-block link-info">pearland&#64;safarivet.com</a>
                </li>
                <li class="mt-2 mt-sm-0">
                  <span>Phone Number</span>
                  <a href="tel:346-688-7678" class="d-block link-info">346-688-7678</a>
                </li>
                <li class="mt-2 mt-sm-0">
                  <span>Fax</span>
                  <a href="tel:801-303-7066" class="d-block link-info">801-303-7066</a>
                </li>
                <li class="mt-lg-0 mt-2">
                  <span>Address</span>
                  <a class="d-block link-info cursor-pointer" (click)="
                      utils.getLatLongFromAddress(
                        '3525 South Main Suite 118, Pearland, TX 77581'
                      )
                    ">
                    3525 South Main Suite 118, Pearland, TX 77581</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="social-details d-flex align-items-center mt-4 mt-xl-0">
            <div class="d-flex justify-content-between w-100 d-xl-block flex-column flex-sm-row">
              <div class="mb-xl-5 mb-4 mb-sm-0 align-self-center">
                Copyright &#xa9; {{currentYear}} safarivet.com
              </div>
              <ul class="justify-content-center">
                <li>
                  <a target="_blank" href="https://www.facebook.com/SafariVeterinaryCareCenters">
                    <i class="fa-brands fa-facebook-f"></i>
                  </a>
                </li>
                <li>
                  <a target="_blank" href="https://vimeo.com/channels/safaripetrehabilitation">
                    <i class="fa-brands fa-vimeo-v"></i>
                  </a>
                </li>
                <li>
                  <a target="_blank" href="https://twitter.com/docgarner">
                    <i class="fa-brands fa-x-twitter"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>